/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation VendorAccountUpdateMutation(
    $vendorAccountId: ID!,
    $displayName: String!
) {
  VendorAccountUpdate(
    vendorAccountId: $vendorAccountId,
    displayName: $displayName
  ) {
    id,
    message,
    status,
    Smpp {
      id
    }
  }
}
`
